import { render } from "./GestionRecommandations.vue?vue&type=template&id=7c244967&scoped=true"
import script from "./GestionRecommandations.vue?vue&type=script&lang=js"
export * from "./GestionRecommandations.vue?vue&type=script&lang=js"

import "./GestionRecommandations.vue?vue&type=style&index=0&id=7c244967&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c244967"]])

export default __exports__